import type { AchievementType } from '../api/types'
import {
  ACHIEVEMENT_CAROUSELS,
  type AchievementCarouselSection,
} from '../constants/home'
import type { PartnerLogo } from './mapContent'

/** How many full logo sets are needed so one marquee group spans the viewport. */
export function partnerMarqueeCopies(
  logoCount: number,
  itemWidthPx: number,
  viewportWidthPx: number,
  minItems: number,
): number {
  if (logoCount <= 0) return 0
  const safeItemWidth = Math.max(itemWidthPx, 1)
  const safeViewport = Math.max(viewportWidthPx, 1)
  const byWidth = Math.ceil((safeViewport * 1.75) / (safeItemWidth * logoCount))
  const byCount = Math.ceil(minItems / logoCount)
  return Math.max(2, byWidth, byCount)
}

export function buildPartnerMarqueeSequence(
  logos: PartnerLogo[],
  copies: number,
): PartnerLogo[] {
  if (logos.length === 0 || copies <= 0) return []
  const sequence: PartnerLogo[] = []
  for (let copy = 0; copy < copies; copy += 1) {
    for (const logo of logos) {
      sequence.push(logo)
    }
  }
  return sequence
}

/** Keep perceived scroll speed stable as the rail grows. */
export function partnerMarqueeDurationSec(
  sequenceLength: number,
  baseDurationSec: number,
  minItems: number,
): number {
  if (sequenceLength <= 0) return baseDurationSec
  const scale = Math.max(1, sequenceLength / Math.max(minItems, 1))
  return Math.round(baseDurationSec * scale * 10) / 10
}

export function groupPartnerLogosByType(
  logos: PartnerLogo[],
): AchievementCarouselSection[] {
  return ACHIEVEMENT_CAROUSELS.map((carousel) => ({
    type: carousel.type,
    title: carousel.title,
    logos: logos.filter((logo) => logo.achievementType === carousel.type),
  })).filter((section) => section.logos.length > 0)
}

export function findAchievementCarousel(
  sections: AchievementCarouselSection[],
  type: AchievementType,
): AchievementCarouselSection | null {
  return sections.find((section) => section.type === type) ?? null
}
